import { Box, CircularProgress } from '@mui/material'

export function ChatLoader() {
  return (
    <Box
      sx={{
        flex: 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: 'text.secondary',
        backgroundColor: 'white',
      }}
    >
      <CircularProgress />
    </Box>
  )
}
